const blocksHandle = process.env.NEXT_PUBLIC_SITE_HANDLE

export const QueryText = `
    ... on ${blocksHandle}ContentBlocks_text_BlockType {
        id
        theme
        columns
        maxWidth
        center
        anchorId
        textBlocks {
            ... on textBlocks_BlockType {
                id
                body
            }
        }
    }
`

export const QueryFlipFlops = `
    ... on ${blocksHandle}ContentBlocks_flipFlops_BlockType {
        id
        theme
        flipStartOrder
        anchorId
        flipFlops {
            ... on flipFlops_BlockType {
                id
                hero {
                    url
                    width
                    height
                }
                body
            }
        }
    }
`

export const QueryFloaters = `
    ... on ${blocksHandle}ContentBlocks_floaters_BlockType {
        id
        theme
        maxWidth
        flipStartOrder
        anchorId
        floaters {
            ... on floaters_BlockType {
                id
                body
                hero {
                    url
                    width
                    height
                }
                heroSize
            }
        }
    }
`

export const QueryBillboards = `
    ... on ${blocksHandle}ContentBlocks_billboard_BlockType {
        id
        height
        tint
        verticalAlign
        horizontalAlign
        maxContentWidth
        anchorId
        hero {
            id
            url
            width
            height
        }
        body
    }
`

export const QueryBillboardSliders = `
    ... on ${blocksHandle}ContentBlocks_billboardSlider_BlockType {
        id
        height
        tint
        verticalAlign
        horizontalAlign
        maxContentWidth
        anchorId
        slides {
            ... on slides_BlockType {
                id
                hero {
                    id
                    url
                    width
                    height
                }
                body
            }
        }
    }
`

export const QueryImpactFigures = `
    ... on ${blocksHandle}ContentBlocks_impactFigures_BlockType {
        id
        theme
        anchorId
        impactFigures {
            ... on impactFigures_BlockType {
                id
                figure
                label
            }
        }
    }
`

export const QueryVideos = `
    ... on ${blocksHandle}ContentBlocks_video_BlockType {
        id
        theme
        maxWidth
        anchorId
        videoShareUrl
    }
`

export const QueryForm = `
    ... on ${blocksHandle}ContentBlocks_hubspotForm_BlockType {
        id
        theme
        maxWidth
        body
        anchorId
        hubspotForm {
            ... on hubspotForm_BlockType {
                id
                formId
                portalId
            }
        }
    }
`

export const QueryProfileCarousel = `
    ... on ${blocksHandle}ContentBlocks_profilesCarousel_BlockType {
        id
        theme
        heading
        text
        anchorId
        ctaButton {
            ... on ctaButton_BlockType {
                id
                buttonLabel
                buttonLink
            }
        }
        profiles {
            ... on profiles_profile_Entry {
                id
                title
                slug
                positions {
                    ... on positions_BlockType {
                        jobTitle
                        organisation
                    }
                }
                avatar {
                    height
                    width
                    url
                }
            }
        }
    }
`

export const QuerySEO = `
    seomatic (asArray: true) {
        metaTitleContainer
        metaTagContainer
        metaLinkContainer
        metaScriptContainer
        metaJsonLdContainer
        metaSiteVarsContainer
        frontendTemplateContainer
    }
`

export const QueryImages = `
    ... on ${blocksHandle}ContentBlocks_images_BlockType {
        id
        theme
        columns
        gap
        maxWidth
        anchorId
        images {
            id
            url
            width
            height
        }
    }
`

export const QueryPageHeader = `
    ... on ${blocksHandle}ContentBlocks_pageHeader_BlockType {
        id
        theme
        body
    }
`

export const QueryOffsetCallout = `
    ... on ${blocksHandle}ContentBlocks_offsetCallout_BlockType {
        id
        theme
        followsPageHeader
        body
        hero {
            id
            url
            height
            width
        }
        graphicOverlayText {
            id
            height
            width
            url
        }
        graphicOverlayImage {
            id
            height
            width
            url
        }
    }
`

export const QueryCards = `
    ... on ${blocksHandle}ContentBlocks_cards_BlockType {
        id
        theme
        columns
        maxWidth
        center
        anchorId
        layout
        aspectRatio
        width
        cards {
            ... on cards_card_BlockType {
                id
                body
                hero {
                    url
                    width
                    height
                }
                
            }
        }
    }
`

export const QuerySpacer = `
    ... on ${blocksHandle}ContentBlocks_spacer_BlockType {
        id
        theme
    }
`

export const QueryDividers = `
    ... on ${blocksHandle}ContentBlocks_dividerHeading_BlockType {
        id
        theme
        anchorId
        heading
    }
`

export const QueryPartners = `
    ... on ${blocksHandle}ContentBlocks_partnerGroups_BlockType {
        id
        partnerGroups {
            ... on partnerGroups_default_Entry {
                id
                title
                size
                partners {
                    ... on partners_partner_Entry {
                        id
                        slug
                        title
                        partnerLogo {
                            id
                            url
                            width
                            height
                        }
                        partnerProfile
                        website
                    }
                }
            }
        }
    }
`

export const QueryProfileGroups = `
    ... on ${blocksHandle}ContentBlocks_profileGroups_BlockType {
        id
        speakerProfileGroups {
            ... on profileGroups_default_Entry {
                id
                profiles {
                    ... on profiles_profile_Entry {
                        id
                        title
                        slug
                        positions {
                            ... on positions_BlockType {
                                jobTitle
                                organisation
                            }
                        }
                        avatar {
                            height
                            width
                            url
                        }
                    }
                }
            }
        }
    }
`

export const QueryTestimonials = `
    ... on ${blocksHandle}ContentBlocks_testimonials_BlockType {
        id
        theme
          testimonials {
            ... on testimonials_testimonial_BlockType {
                id
                avatar {
                    id
                    url
                    width
                    height
                }
                quote
                fullName
                jobTitle
                organisation
            }
        }
    }
`

export const QueryCustomFrontendModule = `
    ... on ${blocksHandle}ContentBlocks_customModule_BlockType {
        id
        heading
    }
`